<template>
  <v-list>
    <v-list-item>
      <v-switch dense readonly inset label="Share Timetable" color="accent"
                :input-value="scheduleMeta.shared" :value="scheduleMeta.shared" :disabled="!scheduleMeta.id"
                :loading="loading" @click="$emit('toggleSharedStatus')" @click.stop data-cy="share_toggle"
      />
    </v-list-item>
    <v-list-item v-if="scheduleMeta.shared">
      <ShareButton style="width: 100%" message="Timetable link copied to clipboard!"
                   :value="scheduleMeta.id">
        <v-btn small outlined block color="accent" :disabled="!scheduleMeta.shared" data-cy="copy_share_link">
          <v-icon left>mdi-link-variant-plus</v-icon> Copy Link
        </v-btn>
      </ShareButton>
    </v-list-item>
    <v-list-item v-if="scheduleMeta.shared" style="min-height: 30px">
      <small class="accent--text font-weight-medium pb-2">*Your @username will also be shared</small>
    </v-list-item>
  </v-list>
</template>

<script>
import ShareButton from '@/components/ShareButton'

export default {
  name: 'ShareTimetable',
  components: { ShareButton },
  props: {
    scheduleMeta: {},
    loading: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
>>>.v-input--selection-controls {
  margin: 0;
}

>>>.v-messages { display: none }
</style>
